export const TRANSLATIONS_FA = {
  name: " مدیریت پروژه رایبد",
  subscriber: "اختصاصی شرکت",
  userName: "نام کاربری",
  password: "رمز عبور",
  enterUserName: "نام کاربری خود را وارد کنید",
  userNameLength: "نام کاربری باید حداقل 5 کاراکتر باشد...",
  enterPassword: "رمز عبور خود را وارد کنید...",
  passwordLength: "رمز عبور حداقل باید ۶ کاراکتر باشد...",
  login: "ورود به سامانه",
  designed: " طراحی و توسعه توسط گروه مهندسین رایبد روش.",
  myProject: "پروژه های من",
  otherProject: "دیگر پروژه ها",
  newProject: "پروژه جدید",
  signOut: "خروج از حساب",
  changePass: "تغییر رمز عبور",
  currentPass: "رمز عبور فعلی",
  newPass: "رمزعبور جدید",
  passRepeat: "تکرار رمز عبور جدید",
  register: "ثبت",
  onRegister: "درحال ثبت...",
  cancel: " انصراف",
  enterCurrentPass: "رمز عبور فعلی  را وارد کنید",
  enterNewPass: "رمز عبور جدید  را وارد کنید",
  confirmPass: "رمزعبور جدید مطابقت ندارد",
  projectCode: "کد پروژه",
  projectDescription: "شرح پروژه",
  fileDrive: "فایل درایو",
  documentManagement: "مدیریت مدارک",
  procurementManagement: "مدیریت  خرید",
  operationManagement: "مدیریت اجرا",
  projectMenu: "پروژه",
  aboutProject: "درباره پروژه",
  projectTeam: "تیم پروژه",
  dashboard: "داشبورد",
  bi: "هوش تجاری",
  help: "راهنما",
  public: "عمومی",
  private: "شخصی",
  shared: "مشترک",
  deleted: "حذف شده",
  documentList: "لیست مدارک",
  documentPreparation: "تهیه مدارک",
  transmittal: "ترانسمیتال",
  comment: "کامنت",
  tq: "TQ",
  ncr: "NCR",
  projectList: "لیست پروژه ها",
  edit: "ویرایش",
  save: "ذخیره",
  timeTable: "زمانبندی پروژه",
  startDate: "تاریخ شروع",
  endDate: "تاریخ پایان",
  effectiveDate: "تاریخ موثر شدن",
  duration: "مدت",
  timetableUndefined: "زمانبندی مشخص نشده است!",
  day: "روز",
  startDatebeforeEndDate: " تاریخ شروع باید قبل از تاریخ پایان باشد!",
  startDatebeforeEffectiveDate: " تاریخ شروع باید قبل از تاریخ موثر شدن باشد!",
  endDateAfterStartDate: " تاریخ پایان باید بعد از تاریخ شروع باشد!",
  endDateAfterEffectiveDate: " تاریخ پایان باید بعد از تاریخ موثر شدن باشد!",
  effectiveDateAfterStartDate: " تاریخ موثر شدن باید بعد از تاریخ شروع باشد!",
  effectiveDateBeforeEndDate: " تاریخ موثر شدن باید قبل از تاریخ پایان باشد!",
  client: "کارفرما",
  clientCode: "کد کارفرما",
  tel: "تلفن",
  address: "آدرس",
  clientUndefined: "کارفرما انتخاب نشده است!",
  clientRemove: " حذف کارفرما",
  consultant: "مشاور",
  consultantCode: "مشاور کد",
  consultantUndefined: "مشاور انتخاب نشده است!",
  consultantRemove: " مشاور حذف",
  attachments: "پیوست ها",
  uploadFiles: "آپلود فایل",
  noFiles: " فایل اضافه نشده است!",
  coding: "کدینگ",
  documentRev: "ویرایش مدرک",
  mrp: "برنامه تامین",
  pr: "درخواست خرید",
  rfp: " درخواست پیشنهاد",
  prc: "قرارداد خرید",
  po: "سفارش خرید",
  pk: "پکینگ",
  receipt: "رسید",
  wr: "درخواست کالا از انبار",
  dispatch: "خروج از انبار",
  invoice: "فاکتور خرید",
  paymentRequest: "درخواست پرداخت",
  payment: "پرداخت",
  codingType: "نوع کدینگ",
  numberType: "عددی",
  alphabetType: "حروفی",
  fixedChar: "کاراکتر ثابت",
  counterFormat: "فرمت شمارنده",
  codingSample: "نمونه کدینگ",
  users: "کاربران ",
  clientUsers: " کارفرما/مشاور",
  newUser: "کاربر جدید",
  exportExcel: "خروجی اکسل",
  search: "جستجو",
  advancedSearch: "جستجوی پیشرفته",
  user: "کاربر",
  email: "ایمیل",
  mobile: "موبایل",
  status: "وضعیت",
  active: "فعال",
  inactive: "غیرفعال",
  companyName: "نام شرکت",
  roleList: "لیست نقش های",
  section: "بخش",
  acl: "لیست دسترسی",
  view: "مشاهده",
  manage: "مدیریت",
  archive: "آرشیو",
  unlimitedView: "مشاهده آزاد",
  conditionalView: "مشاهده محدود",
  fullView: "مشاهده کامل",
  activityUpdate: "بروزرسانی فعالیت",
  createRevision: "ایجاد ویرایش",
  confirm: "تایید",
  unlimitedConfirm: "تایید آزاد",
  reply: "پاسخ",
  equipmentList: "لیست تجهیزات",
  equipment: "تجهیزات",
  preInvoiceRegister: "ثبت پیش فاکتور",
  techProposal: "پروپوزال فنی",
  commercialProposal: "پروپوزال بازرگانی",
  proposalSelection: "انتخاب پروپوزال برنده",
  logistics: "لجستیک",
  poActivity: "فعالیت های سفارش",
  poFinancial: "مالی سفارش",
  poInspection: "بازرسی ساخت",
  supplierDocument: "مدارک تامین کننده",
  inventory: "موجودی انبار",
  supplierAccount: "صورتحساب تامین کنندگان",
  packingManage: "مدیریت پکینگ",
  packingInspection: "بازرسی پکینگ",
  transferManagement: "مدیریت حمل و نقل",
  update: "بروزرسانی",
  qc: "کنترل کیفیت",
  techEval: "ارزیابی فنی",
  CommercialEval: "ارزیابی بازرگانی",
  operationList: "لیست عملیات",
  operationExecution: "انجام عملیات",
  groupCode: "کد گروه",
  groupTitle: "شرح گروه",
  selectedGroup: "گروه های انتخاب شده",
  add: "افزودن",
  added: "اضافه شد",
  documentGroupLimitation: "محدودیت گروه مدارک ",
  productGroupLimitation: "محدودیت گروه کالا ",
  operationGroupLimitation: "محدودیت گروه عملیات ",
  addUser: " افزودن کاربر",
  userFirstName: "نام",
  userLastName: "نام خانوادگی",
  selectedUsers: "کاربران انتخاب شده",
  documentInprogress: " مدارک در جریان تهیه",

  pendingConfirmationDocuments: "مدارک منتظر  تایید",
  pendingTransmittalDocuments: "مدارک منتظر  ترانسمیتال",
  replyPendingComments: "کامنت های منتظر  پاسخ ",
  replyPendingTq: "TQ های منتظر  پاسخ ",
  replyPendingNcr: "NCR های منتظر  پاسخ ",

  pendingConfirmationPurchaseRequests: "منتظر  تایید درخواست خرید ",
  pendingRegisterRfps: "منتظر  ثبت درخواست پیشنهاد",
  inProgressRfps: "در جریان درخواست پیشنهاد ",
  PendingRegisterPurchaseOrders: "منتظر  ثبت سفارش ",
  inProgressPurchaseOrders: "در جریان سفارش ",
  inProgressOperations: "عملیات در جریان ",

  title: "عنوان",
  code: "کد",
  group: "گروه",
  class: "کلاس",
  creator: "ثبت",
  dueDate: "تاریخ سررسید",
  revision: "ویرایش",
  pendingModification: "منتظر اصلاح",
  reason: "علت",
  documents: "مدارک",
  document: "مدرک",
  folderEmpty: "فولدر خالیست!",
  accessLimited: "محدودیت دسترسی",
  accessLimitedDes: "شما مجوز ورود به این بخش را ندارید!",
  callAdmin: "با ادمین سیستم تماس بگیرید!",
  remove: "حذف",
  documentsPendingRegister: "درانتظار ثبت مدارک",
  newDocuments: "مدارک جدید",
  area: "ناحیه",
  lastRevision: "آخرین ویرایش",
  status: "وضعیت",
  inProgress: "درجریان",
  pendingConfirmation: " منتظر  تایید",
  confirmed: "تایید شده",
  TransmittalIfa: "ترانسمیتال IFA",
  TransmittalIfi: "ترانسمیتال IFI",
  TransmittalIfc: "ترانسمیتال IFC",
  TransmittalIfr: "ترانسمیتال IFR",
  TransmittalIff: "ترانسمیتال IFF",
  TransmittalAsb: "ترانسمیتال ASB",
  filter: "فیلتر",
  filtering: "درحال فیلتر ...",
  transmittalRequired: "الزام به ترانسمیتال",
  rejected: "تایید نشده",
  nothing: "ندارد",
  all: "همه موارد",
  importExcel: "ورود از اکسل",
  excelFormat: "فرمت اکسل",
  clientNumber: "کد کارفرما",
  linkedItems: " آیتم های مرتبط",
  remark: "توضیحات",
  yes: "بله",
  no: "خیر",
  history: "تاریخچه تغییرات",
  documentRevisions: " لیست ویرایش های مدرک",
  number: "شماره",
  date: "تاریخ",
  confirmationWorkflow: "گردش کار تایید",
  communication: "مکاتبات",
  receiverCompany: "شرکت گیرنده",
  receiverPerson: "شخص گیرنده",
  type: "نوع",
  close: "بستن",
  registered: "ثبت شده",
  edited: "ویرایش شده",
  activated: "فعال شده",
  inactivated: "غیر فعال شده",
  preparedBy: " تهیه شده توسط",
  otherPersons: " نفر دیگر",
  and: " و",
  onDate: "در تاریخ",
  confirmedBy: "تایید شده توسط",
  persons: "نفر",
  filesUploaded: "فایل بارگذاری شده است",
  transmittedOn: "ترانسمیتال شده در تاریخ",
  newRevision: "ویرایش جدید",
  onlyRejected: " فقط منتظر اصلاح",
  lastRevisionCode: "آخرین ویرایش",
  finalizing: "نهایی سازی",
  deActivate: "غیر فعال کردن",
  finalizingHistory: "تاریخچه نهایی سازی",
  files: "فایل ها",
  activities: "فعالیت ها",
  commentAndReply: "پرسش و پاسخ",
  newActivity: "فعالیت جدید",
  responsible: "مسئول",
  registeredWorkingTime: "زمان کاری ثبت شده",
  workingTime: "زمان کاری",
  newComment: "پرسش جدید",
  typeYourComment: "پرسش خود را اینجا بنویسید ...",
  send: "ارسال",
  sending: "درحال ارسال",
  attachment: "پیوست",
  copy: "کپی",
  typeYourReply: "پاسخ خود را اینجا بنویسید ...",
  aMomentAgo: "چند لحظه پیش",
  dragFiles: "فایل خود را اینجا بیندازید ...",
  specifications: "مشخصات",
  paperSize: "سایز صفحات",
  pageNumbers: "تعداد صفحات",
  description: "شرح",
  selectFileFromRevisionDetail: " انتخاب فایل از جزییات ویرایش",
  addConfirmer: "افزودن تایید کننده",
  selectConfirmer: "انتخاب تایید کننده",
  finalizingWithoutWf: "آیا نهایی سازی بدون گردش کار ثبت شود؟",
  select: "انتخاب",
  selectFile: "انتخاب فایل",
  deactivateRevisionWarning: "آیا میخواهید مدرک لغو شود؟ ",
  revisionDeactivated: "این مدرک غیرفعال شده است!",
  revisionPendingConfirmation: "این مدرک برای تایید ارسال شده است!",
  revisionConfirmed: "این مدرک تایید شده است!",
  revisionTransmitted: "این مدرک ترانسمیتال شده است!",
  sentBy: "ارسال شده توسط",
  revisionConfirmation: "تایید ویرایش",
  reject: "عدم تایید",
  otherWf: "گردش های قبلی",
  result: "نتیجه",
  rejectReason: "لطفا علت عدم تایید را وراد نمایید!",
  transmittalList: "لیست ترانسمیتال",
  pendingTransmittal: "درانتظار ثبت ترانسمیتال",
  newTransmittal: "ترانسمیتال جدید",
  filtering: "درحال فیلتر...",
  sender: "فرستنده",
  receiver: "گیرنده",
  cc: "رونوشت",
  content: "محتوا",
  subject: "موضوع",
  selectedDocuments: "مدارک انتخاب شده",
  cancelWarning: "در صورت انصراف، کلیه اطلاعات این صفحه حذف میشود!",
  commentList: "لیست کامنت ها",
  commentOrDocument: "کامنت / مدرک",
  Issuer: "صادر کننده",
  pendingReply: "منتظر پاسخ",
  replyed: "پاسخ داده شده",
  closed: "بسته شده",
  replyRegistrant: "ثبت کننده پاسخ",
  commentStatus: "وضعیت کامنت",
  commentRegistrant: "ثبت کننده کامنت",
  details: "جزییات",
  comments: "کامنت ها",
  replyRegistration: "ثبت پاسخ",
  commentsReplyed: "پاسخ ها ثبت شده است!",
  commentClosed: "کامنت بسته شده است!",
  TypeComment: "کامنت خود را تایپ و در انتها Enter  را بزنید ...",
  newTq: "TQ  جدید",
  tqList: "لیست TQ ",
  tqRegistrant: "ثبت کننده ",
  replyRegistrant: "ثبت کننده پاسخ",
  tqReplyed: "پاسخ ها ثبت شده است!",
  tqClosed: "مکاتبه بسته شده است!",
  TqOrDocument: "TQ  / مدرک",
  newNcr: "NCR جدید",
  ncrList: "NCR لیست",
  ncrRegistrant: "ثبت کننده",
  ncrOrDocument: "NCR  / مدرک",
  ncrReplyed: "پاسخ ها ثبت شده است!",
  ncrClosed: "مکاتبه بسته شده است!",
  design: "طراحی",
  supplier: "تامین کننده",
  contractor: "پیمانکار اجرایی",
  noProjectTeamFound: " شما به هیچ تیم پروژه ای اضافه نشده اید!",
  ok: "متوجه شدم",
  permanentDelete: "حذف دائم",
  permanentDeleteWarning:
    " درصورت ادامه، فایل یا فولدر به صورت دائم حذف می شود! ",
  allItem: "همه موارد",
  activate: "فعال کردن",
  documentDeactivateWarning:
    "درصورت غیر فعال کردن مدرک، امکان ایجاد ویرایش غیر ممکن می شود!",
  download: "دانلود",
  newCommentSheet: "کامنت جدید",

  commented: "تایید نشده",
  approved: "تایید شده",
  approvedAsNoted: "تایید مشروط",
  commentRejected: "غیر قابل بررسی",
  commentAfc: " کامنت AFC ",
  userRemove: "آیا از حذف این کاربر مطمئن هستید؟",
  deleteFile: "حذف فایل",
  deleteFileWarning: "آیا از حذف فایل مطمئن هستید؟",
  globalReply: "ثبت پاسخ آزاد",
  editDocument: "ویرایش مدرک ",
  notifSetting: "تنظیمات اعلانات",
  profile: "حساب کاربری",
  reminder: "یادآوری",
  event: "رویداد",
  forgotPassword: "رمز عبور را فراموش کرده اید؟",
  sendRecoveryLink: "ارسال لینک بازیابی رمز عبور",
  backToLogin: "بازگشت به صفحه ورود",
  passwordRecoveryFor: "بازیابی رمز عبور برای",
  recoveryExpired: " لینک بازیابی رمز عبور منقضی شده است!",
  recoveryLinkSent: "لینک بازیابی رمز عبور به ایمیل شما ارسال شد!",
  latestDocumentsStatusList: "لیست آخرین وضعیت مدارک",
  latestRevisionsStatusList: "لیست آخرین وضعیت ویرایش ها",
  revisionsHistoryList: "لیست تاریخچه  ویرایش ها",
  internal: "داخلی",
  transmittalType: "نوع ترانسمیتال",
  documentGroup: "گروه مدارک",
  generalComment: " کامنت عمومی",
  commentSheet: "کامنت شیت",
  commentAttachment: "پیوست کامنت",
  replyAttachment: "پیوست پاسخ",
  warehouse: "انبار",
  financial: "مالی",
  comprehensiveList: "لیست تجهیزات",
  treeList: "لیست درختی",
  newEquipment: "تجهیز جدید",
  unplanned: "برنامه ریزی نشده",
  planned: "برنامه ریزی شده",
  rfpInProgress: "در جریان RFP",
  rfpEvaluated: "RFP  ارزیابی شده",
  supplierSelection: "انتخاب تامین کننده",
  poInProgress: "سفارش در جریان",
  delivered: "تحویل شده",
  newEquipmentList: "لیست تجهیزات جدید",
  selectFromEqList: "انتخاب از لیست تجهیزات",
  informationIssue: "نقص اطلاعات",
  informationIssueDes:
    " برای افزودن  باید کد، عنوان، واحد شمارش و مقدار نیاز پر شده باشد! ",
  groupIssue: "برای افزودن  باید گروه را انتخاب نمایید",
  technicalCode: "شماره فنی",
  requiredQuantity: "مقدار نیاز",
  planningRequired: "الزام به برنامه ریزی",
  no: "خیر",
  yes: "بله",
  importExcelError:
    "اطلاعات ورودی معتبر نیستند. برای جلوگیری از خطا، حتما از فرمت اکسل ارایه شده استفاده کنید!",
  pendingForComponent: "منتظر ثبت زیر مجموعه",
  unit: "واحد",
  completed: "تکمیل شده",
  part: "مواد اولیه",
  component: "قطعه",
  quantity: "مقدار",
  reqirementList: "لیست مقدار نیاز",
  reference: "رفرنس",
  remained: "مانده",
  grossRequirement: "نیاز ناخالص",
  netRequirement: "نیاز خالص",
  finalRequirement: "نیاز نهایی",
  start: "شروع",
  finish: "پایان",
  techprop: "پروپوزال فنی",
  commerceProp: "پروپوزال بازرگانی",
  proposalEvaluation: "ارزیابی پروپوزال",
  proposalSelection: "انتخاب پروپوزال",
  setting: "تنظیمات",
  usersDes: "برای اضافه کردن کاربر، حذف و ویرایش اطلاعات کاربران ، کلیک کنید!",
  teams: "تیم ها",
  producGroup: "گروه کالا",
  operationGroup: "گروه اجرا",
  clients: "کارفرما ها",
  consultants: "مشاوران",
  suppliers: "تامین کنندگان",
  totalUsers: "تعداد کاربران",
  ForUsers: "نام",
  userAccess: "دسترسی کاربر",
  submit: "ثبت",
  upload: "بارگذاری",
  firstnameIsrequired: " نام خود را وارد کنید!",
  lastnameIsrequired: " نام خانوادگی را وارد کنید!",
  emailIsRequied: "ایمیل را وارد کنید!",
  emailValidation: "ایمیل وارد شده معتبر نیست!",
  firstnameLength: " طول نام باید بین 2 تا 50 کاراکتر باشد!",
  lastnameLength: "طول نام خانوادگی باید بین 2 تا 50 کاراکتر باشد!",
  mobileLength: " حداکثر طول مجاز برای موبایل 13 کاراکتر می باشد!",
  mobileValidation: " موبایل وارد شده معتبر نیست!",
  userEdit: "ویرایش کاربر",
  userActivated: "کاربر فعال شد!",
  userInactivated: "کاربر غیرفعال شد!",
  userRemove: "آیا از حذف کاربر مطمئن هستید؟",
  organizational: "سازمانی",
  totalGroups: "تعداد گروه",
  addGroup: "افزودن گروه",
  clickHereToAddNew: "  برای شروع روی دکمه افزودن کلیک کنید!",
  groupRemove: "آیا از حذف گروه مطمئن هستید؟",
  editGroup: "ویرایش گروه",
  totalClients: "تعداد کارفرماها",
  addClient: "افزودن کارفرما",

  fax: "فکس",
  postalCode: "کد پستی",
  website: "وب سایت",

  companyNameIsrequired: " نام شرکت الزامی می باشد!",
  companyNameLength: " طول نام شرکت باید بین 2 تا 50 کاراکتر باشد!",

  companyCodeIsrequired: " کد شرکت الزامی می باشد!",
  companyCodeLength: " طول کد شرکت باید بین 1 تا 5 کاراکتر باشد!",

  editClient: "ویرایش کارفرما",
  removeClient: "از حذف کارفرما مطمئن هستید؟",
  loginPermission: "امکان ورود به سامانه",
  createUserAccount:
    "در صورت فعال کردن این گزینه، کاربر می تواند به سامانه ورود کند و  یک ایمیل دعوتنامه حاوی اطلاعات ورورد به سامانه برای ایشان ارسال میگردد!",

  totalConsultants: "تعداد مشاوران",
  addConsultant: "افزودن مشاور",
  editConsultant: "ویرایش مشاور",
  removeConsultant: "از حذف مشاور مطمئن هستید؟",
  editConsultant: "ویرایش مشاور",

  totalSuppliers: "تعداد تامین کنندگان",
  addSupplier: "افزودن تامین کننده",
  editSupplier: "ویرایش تامین کننده",
  removeSupplier: "از حذف تامین کننده مطمئن هستید؟",
  editSupplier: "ویرایش تامین کننده",
  economicCode: "کد اقتصادی",
  nationalCode: "شناسه ملی",
  productGroup: "گروه کالا",

  appNewVersion: " نسخه جدید",
  appVersionNo: "نسخه شماره",
  appNewVersionDes:
    " مدیریت پروژه رایبد منتشر شد. برای دریافت آخرین امکانات روی دکمه بروزرسانی کلیک کنید. بروزرسانی ممکن است چند دقیقه طول بکشد و می توانید در این مدت لیست تغییرات جدید را مطاله نمایید!",
  appUpdate: "Update",

  clientPanel: "پنل کارفرما / مشاور ",
  all: "همه موارد",
  pendingComment: "منتظر کامنت",
  pendingMrp: "درانتظار برنامه ریزی",
  mrpList: " لیست برنامه ریزی",
  informationIssueDesDocument:
    " برای افزودن مدرک باید گروه مدرک انتخاب و کد، عنوان و کلاس پر شده باشد!  ",
  reservedInventory: "موجودی رزرو",
  surplusQuantity: " مقدار مازاد",
  pendingRegistration: "در انتظار ثبت",
  prList: "لیست درخواست خرید ها",
  itemNumber: "تعداد آیتم ها",
  selectAll: "انتخاب همه",
  removeAll: "حذف همه",
  selectedList: "لیست انتخاب شده ها",
  operationSucceded: " عملیات با موفقیت انجلم شد! ",
  prConfirmation: "تایید درخواست خرید",
  rfpList: "لیست درخواست پیشنهادات",
  rfpType: "نوع پیشنهاد ",
  proposal: "پروپوزال",
  preInvoice: "پیش فاکتور ",
  techInquiry: "استعلام فنی ",
  commercialInquiry: "استعلام بازرگانی ",
  weight: "وزن",
  whatsYourTechProposal: " پروپوزال فنی شما چیست؟",
  price: "قیمت",
  deliveryTime: "زمان تحویل",
  emptyInquiry: "شرح استعلام نباید خالی باشد",
  supplierEdit: "ویرایش تامین کنندگان",
  commercialInqueryEdit: " ویرایش استعلام بازرگانی",
  techIqueryEdit: "ویرایش استعلام فنی",
  winnerSelection: " انتخاب برنده",
  cancelRfp: " لغو درخواست",
  rfPIsCanceled: "درخواست لغو شده است!  ",
  downloadAll: "دانلود همه ",
  changeDesNotAllowed: "امکان  تغییر شرح وجود ندارد!",
  changeInqNotAllowed: " امکان حذف استعلام وجود ندارد!",
  totalEvaluationScore: "جمع کل امتیاز ارزیابی",
  supplierAnswer: "پاسخ تامین کننده ",
  evaluationScore: "امتیاز ارزیابی ",
  evaluation: "ارزیابی",
  proposalRegister: "ثبت پروپوزال ",
  inquiryList: " لیست استعلام",
  reEvaluation: "ارزیابی مجدد ",
  isEvaluated: "این پروپوزال ارزیابی شده است   !",
  evaluationNotAllowed:
    "به دلیل انتخاب شدن برنده امکان تغییر در پروپوزال و ارزیابی وجود ندارد!",
  fianlScore: " امتیاز نهایی",
  priceEmpty: "لطفا قیمت را وارد کنید  ",
  winnerProposalSelection: "انتخاب پروپوزال برنده",
  techProposalScore: "امتیاز پروپوزال فنی",
  commercialProposalScore: "امتیاز پروپوزال بازرگانی",
  continue: "ادامه",
  cancelRfpWarning: "آیا از لغو درخواست مطمئن هستید؟",
  prcList: "لیست قرارداد خرید",
  newContract: "قرارداد جدید ",
  canceled: "لغو شده",
  rial: "ریال",
  euro: "یورو",
  dollar: "دلار",
  supplierWarehouse: "انبار تامین کننده",
  customsOfOrigin: "گمرک مبدا",
  destinationCustoms: "گمرک مقصد",
  purchaserWarehouse: "انبار خریدار",
  local: "داخلی",
  overseas: "خارجی",
  cancelPrcWarning: "آیا از لغو قرارداد خرید مطمئن هستید؟",
  contractInformation: "مشخصات قرارداد",
  supplierInformation: "مشخصات تامین کننده  ",
  fistSelectSupplier: "ابتدا تامین کننده مورد نظر را انتخاب کنید!",
  contractTimeTable: "زمانبندی قرارداد",
  contractDuration: "مدت قرارداد",
  cancelContract: "لغو قرارداد ",
  contractCondition: " شرایط قرارداد",
  contractType: "نوع قرارداد",
  deliveryLocation: "محل تحویل",
  currency: "واحد پولی",
  vat: "مالیات بر ارزش افزوده",
  contractSubject: "موضوع قرارداد ",
  unitPrice: "قیمت واحد ",
  totalPrice: "قیمت کل ",
  totalAmount: "جمع مبالغ ",
  finalAmount: "مبلغ نهایی",
  paymentTerms: "روش پرداخت",
  percent: "درصد",
  daysCredit: "روزاعتبار",
  paymentOnPoConfirmation: "تائید سفارش/ پیش پرداخت",
  paymentOnPoPreparation: "آماده سازی / ساخت",
  paymentOnPoPacking: "پکینگ سفارش",
  paymentOnInvoice: "صدور فاکتور / رسیدانبار",
  refinalizing: "نهایی سازی مجدد",
  paymentPercentMax: " درصد پرداخت نمیتواند بیش از 100 درصد باشد!",
  totalPaymentPercentMax: "مجموع درصد پرداخت نمیتواند بیش از 100 درصد باشد!",
  poReport: "گزارش سفارش خرید",
  fiReport: "گزارش مالی",
  paid: "پرداخت شده",
  preparation: "آماده سازی",
  poConfirmation: "تایید سفارش",
  overDue: "سررسید شده",
  notOverDue: "سررسید نشده",
  paymentTermsUndefined: "روش پرداخت تعیین نشده است!",
  subjectUndefiend: "موضوع مشخص نشده است!",
  conditionUndefined: "شرایط مشخص نشده است!",
  poList: "لیست سفارشات",
  poDeliveryTime: "تاریخ تحویل سفارش",
  progressPercent: "درصد پیشرفت",
  supplierDocuments: "مدارک تامین کننده ",
  inlineInspection: "بازرسی ساخت",
  cancelPo: " لغو سفارش",
  cancelPoWarning: "آیا از لغو سفارش مطمئن هستید؟",
  poIsCanceled: "  سفارش لغو شده است!",
  progress: "پیشرفت",
  progressValidation: "درصد پیشرفت نباید منفی باشد!",
  packingCancelWarning: "در صورت حذف، امکان بازگشت وجود ندارد!",
  pendingQC: " منتظر کنترل کیفیت",
  purchaseRejection: "برگشت از خرید",
  conditionalAccepatnce: "مجوز ارفاقی",
  qcPass: "تایید کیفی",
  newPacking: "پکینگ جدید",
  inspectedBy: "بازرسی شده توسط",
  pendingInspection: "منتظر بازرسی ",
  inTransitToCustomOfOrigin: "در حال حمل به گمرک مبدا",
  waitingForClearanceFromCustomOfOrigin: "درانتظار ترخیص از گمرک مبدا",
  clearanceInProgressInCustomOfOrigin: "در حال ترخیص از گمرک مبدا",
  waitingForTransitToCustomOfDestination: "در انتظار حمل به گمرک مقصد",
  inTransitToCustomOfDestination: "در حال حمل به گمرک مقصد",
  waitingForClearanceFromCustomOfDestination: "درانتظار ترخیص از گمرک مقصد",
  clearanceInProgressInCustomOfDestination: "در حال ترخیص از گمرک مقصد",
  waitingForTransitToBuyersWarehouse: "در انتظار حمل به انبار خریدار",
  inTransitToBuyersWarehouse: "در حال حمل به انبار خریدار",
  deliveredToBuyersWarehouse: "تحویل شده درب انبار خریدار",
  WarehouseReceipt: "رسید انبار",
  newInspection: "بازرسی جدید ",
  transportation: "حمل و نقل",
  packingValidation: "مقدار پکینگ نمی تواند بیشتر از مانده سفارش باشد!",
  inspection: "بازرسی",
  transitToOrigin: "حمل به گمرک مبداء",
  clearanceFromOrigin: "ترخیص از گمرک مبداء",
  transitToDestination: "حمل به گمرک مقصد",
  clearanceFromDestination: "ترخیص از گمرک مقصد",
  transitToWarehose: "حمل به انبار خریدار",
  paymentAmount: "مبلغ پرداخت ",
  poInvoices: "فاکتورهای سفارش  ",
  paymentRequestValidation:
    " مبلغ درخواستی باید کمتر از مبلغ قابل پرداخت باشد!",
  newPaymentRequest: "درخواست پرداخت جدید  ",
  payableAmount: "مبلغ قابل پرداخت ",
  requestAmount: "مبلغ درخواست ",
  other: "سایر",
  removePaymentRequestWarning: "آیا از حذف درخواست پرداخت مطمئن هستید؟",
  removeDocumentWarning: "آیا از حذف  مدرک مطمئن هستید؟",
  removeInspectionWarning: "آیا از حذف بازرسی مطمئن هستید؟",
  pendingInspecttion: "منتظر بازرسی",
  inspectionRequest: "درخواست بازرسی",
  inspector: "بازرس",
  productRequest: "درخواست کالا ",
  warehouseInput: "ورود به انبار",
  warehouseOutput: "خروج از انبار",
  warehouseInventory: "موجودی انبار ",
  requestList: "لیست درخواست ها ",
  newRequest: "درخواست جدید ",
  selectEquipment: "لطفا تجهیز را انتخاب کنید",
  receiptList: "لیست رسید ها",
  receiptValidation: " مقدار رسید نمی تواند بیشتر از مقدار پک باشد!",
  qcValidation: " مقدار پذیرش نمی تواند بیشتر از مقدار رسید باشد!",
  transferoutList: "لیست خروج ها",
  transferoutValidation1: "مقدار تحویل نمی تواند بیشتر از مقدار موجودی باشد!",
  transferoutValidation2: "مقدار تحویل نمی تواند بیشتر از مقدار درخواست باشد!",
  cancelDelivery: "لغو تحویل ",
  compeletedDelivery: "تحویل کامل ",
  partialDelivery: "تحویل ناقص ",
  lastChanges: " آخرین تغییرات ",
  kardex: "کاردکس",
  financialStatement: "صورتحساب",
  pendingPayment: "درانتظار پرداخت",
  paymentList: "لیست پرداخت ها",
  paymentCancelWarning: "در صورت لغو امکان بازگشت وجود ندارد!",
  payedAmount: "مبلغ پرداخت شده",
  cancelPayment: "لغو",
  paymentValidation: "برای افزودن پرداخت باید مقدار پرداخت پر شده باشد!",
  paymentValidation2: "مبلغ پرداخت نباید بیشتر از مانده باشد!",
  invoiceList: "لیست فاکتورها",
  rejectionInvoice: " فاکتور برگشت از خرید",
  accountType: "نوع حساب",
  purchaseInvoice: "فاکتور خرید ",
  accountList: "لیست حساب ",
  newOperation: "عملیات جدید ",
  notStarted: "شروع نشده ",
  startOperation: "شروع عملیات ",
  operationDeactiveWarning:
    "درصورت غیر فعال کردن عملیات، امکان بروزرسانی آن غیر ممکن می شود!",
  dueDateWarning: "تاریخ سررسید را تکمیل نمایید!",
  operation: "عملیات",
  operationFinalizingWarning:
    "در صورت نهایی سازی عملیات، وضعیت عملیات به انجام شده تغییر می باید!",
  cancelOperationWarning:
    "در صورت ادامه، عملیات به وضعیت شروع نشده تغییر می کند!",
  cancelOperation: " لغو عملیات ",
  cancelFinalizingOperationWarning:
    "در صورت ادامه، عملیات به وضعیت در حال انجام تغییر می کند!",
  cancelFinalizing: "لغو نهایی سازی",
  operationFinalized: "عملیات نهایی شده است!",
  operationIsCanceled: "عملیات کنسل شده است!",
  commentsheetCode: "کد کامنت شیت",
  getNewCommentsheetCode: "برای دریافت کد معتبر کلیک کنید!",
  click: "کلیک",
  revisionFileEdit: "ویرایش فایل ها",
  fileType: "نوع فایل",
  fileSize: "حجم فایل",
  newFiles: "فایل های جدید",
  currentFiles: "فایل های فعلی",
  editTr: "ویرایش ترانسمیتال",
  lastConfirmedRevision: "آخرین ویرایش تایید شده",
  prQuantityValidation:
    "مقدار درخواست خرید باید کمتر یا مساوی از مقدار نیاز باشد!",
  contractAmendment: "الحاقیه قرارداد",
  commentsheetEdit: "ویرایش کامنت شیت",
  amendment: "الحاقیه",
  selectedEquipment: "تجهیزات انتخاب شده",
  approvedForConstruction: "تایید برای ساخت",
  requirement: "نیاز",
  removeEqWarning: "آیا از حذف تجهیز  مطمئن هستید؟",
  removeDocWarning: "آیا از حذف مدرک  مطمئن هستید؟",
  set: "مجموعه",

  nonconformity: "عدم انطباق ",
  nonconformityList: "لیست عدم انطباق",
  pendingAction: "منتظر اقدام",
  newNonconformity: "عدم انطباق جدید",
  process: "فرایند",
  pendingForAction: "منتظر اقدام",
  correctiveActions: "اقدامات اصلاحی و پیشگیرانه",
  consequence: "پیامد",
  source: "منبع",
  preventive: "پیشگیرانه",
  corrective: "اصلاحی",
  cancelNcWarning: "در صورت ادامه، عدم انطباق لغو می شود!",
  ncCancel: "لغو عدم انطباق",
  pendingPr: "منتظر درخواست خرید",
  totalCompanies: "تعداد کل شرکت ها",
  newCompany: "شرکت جدید",
  companyDetails: "جزییات شرکت",
  removeProject: "حذف پروژه",
  removeProjectWarning: "آیا از حذف این پروژه مطمئن هستید؟",
  informationIssueOpDes: " برای افزودن  باید کد و عنوان پر شده باشد! ",
  delivery: "تحویل",
  hse: "بهداشت و ایمنی ",
  anomalyList: "لیست آنومالی",
  anomalyActions: "اقدامات آنومالی",
  newAnomaly: "آنومالی جدید",
  company: "شرکت",
  workshop: "کارگاه",
  location: "مکان",
  root: "منشا",
  impact: "شدت پیامد",
  category: "دسته بندی",
  immediateActions: "اقدامات فوری",
  rootCause: "علت ریشه ای",
  pendingActionConfirmation: "متنظر تایید اقدامات",
  anomalyActionList: "لیست اقدامات آنومالی",
  cancelAnomaly: "لغو آنومالی",
  transmittaldocument: "ترانسمیتال / مدرک",
  anomaly: "آنومالی",
  trdocuments: "مدرک",
  cancelAnomalyWarning: "در صورت ادامه،  آنومالی لغو می شود!",
  moduleSelection: " انتخاب ماژول ها",
  manufacturingManagement: " مدیریت ساخت",
  partManagement: "مدیریت پارت ها",
  assemblyManagement: "مدیریت مونتاژ",
  basicInformation: "اطلاعات پایه",
  workForce: " نیروی کاری",
  workStage: "مرحله کاری",
  workPackage: "گروه کاری",
  workforceName: " نام و نام خانوادگی",
  personalCode: "شماره پرسنلی",
  jobTitle: "شرح شغلی",
  newWorkforce: "نیروی کار جدید",
  image: "عکس",
  informationIssueWfDes: " برای افزودن  باید کلیه فیلدها پر شده باشد! ",
  newWorkStage: "مرحله کاری جدید",
  removeWorkStageWarning: "آیا از حذف این مرحله کاری مطمئن هستید؟",
  partType: " پارت",
  assemblyType: "مونتاژ",
  newWorkPackage: "گروه کاری جدید",
  workStages: "مراحل کاری",
  workStageSelection: "انتخاب مرحله کاری",
  removeWorkPackageWarning: "آیا از حذف این گروه کاری مطمئن هستید؟",
  partList: "پارت لیست",
  manufacturingPlan: "برنامه ساخت",
  manufacturingReport: "گزارش ساخت",
  phase: "فاز",
  specification: "مشخصات",
  length: "طول",
  area1: "مساحت",
  newPart: "پارت جدید",
  materialType: "نوع متریال",
  removePartWarning: "آیا از حذف این پارت مطمئن هستید؟",
  numbers: "تعداد",
  workPackageSelection: "انتخاب گروه کاری",
  AddManufacturingReport: "گزارش ساخت جدید",
  partSelection: "انتخاب پارت",
  assemblyList: "لیست مونتاژ",
  assemblyPlan: "برنامه مونتاژ",
  assemblyReport: "گزارش مونتاژ",
  newAssembly: "مونتاژ جدید ",
  coefficient: "ضریب مصرف",
  total: "مجموع",
  removeAssemblyWarning: "آیا از حذف این مونتاژ مطمئن هستید؟",
  assemblySelection: "انتخاب مونتاژ",
  partManufacturingReport: "گزارش ساخت پارت",
  assemblyManufacturingReport: "گزارش ساخت مونتاژ",
  formName: "نام فرم",
  cancelWinnerSelection: "لغو انتخاب برنده",
  wfinformationIssueOpDes: "لطفا فیلد های ضروری را وارد کنید!",
  sendInvitation: " ارسال دعوتنامه ",
  publicConversation: "گفتگو عمومی",
  addConversation: "گفتگو جدید",
  projectNews: "اخبار پروژه",
  projectReminders: " یادآوری های پروژه",
  projectNewsLastMessage: "آخرین رویدادهای پروژه",
  projectRemindersLastMessage: "یادآوری فعال!",
  eventNo: "شماره رویداد",
  service: "سرویس",
  markAsCompleted: " پایان تسک",
  markAsIncomplete: "برگشت تسک ",
  members: "اعضا",
  follow: "دنبال کردن",
  viewAllReplies: "مشاهده کل پاسخ ها",
  follower: "دنبال کننده",
  followed: "دنبال شده",
  moreReplies: "پاسخ دیگر ",
  planning: "برنامه ریزی",
  timeManagement: "مدیریت زمان ",
  budgetManagement: "مدیریت بودجه ",
  resourceManagement: "مدیریت منابع ",
  schedulingList: "لیست زمانبندی",
  planStart: "شروع برنامه",
  planFinish: "پایان برنامه",
  planDuration: "مدت  ",
  planProgress: "پیشرفت ",
  floating: "شناوری",
  actualStart: "شروع واقعی ",
  actualFinish: "پایان واقعی ",
  actualDuration: "مدت  ",
  actualProgress: "پیشرفت ",
  delay: "تاخیر",
  planRegistration: "ثبت برنامه",
  codeOrTitle: "کد یا عنوان",
  procurement: "خرید",
  unscheduled: "برنامه ریزی نشده",
  planInProgress: "0 < پیشرفت برنامه < 100",
  planCompleted: " پیشرفت برنامه = 100",
  actualInProgress: "0 < پیشرفت واقعی < 100",
  actualCompleted: " پیشرفت واقعی = 100",
  progressProcedure: "روش اندازه گیری پیشرفت",
  faDocumentProcedurs: "مدیریت مدارک - کلاس FA",
  fiDocumentProcedurs: "مدیریت مدارک - کلاس FI",
  internalProductProcedurs: "مدیریت خرید - خرید داخلی",
  externalProductProcedurs: "مدیریت خرید - خرید خارجی",
  totalPercentage: "جمع درصدها",
  step: "مرحله",
  progressPercent: "درصد پیشرفت ",

  createRevisionStep: "ایجاد ویرایش",
  finalizatingStep: "نهایی سازی ویرایش",
  confirmedStep: "تایید ویرایش",
  transimittalStep: "ترانسمیتال",
  TransmittalIfcStep: "ترانسمیتال IFC",
  commentStep: "ثبت کامنت",
  replyedStep: "پاسخ به کامنت",
  closedStep: "کامنت بسته شده",
  commentAfcStep: "کامنت AFC",
  prStep: "ثبت درخواست خرید",
  PurchaseRequestConfirmStep: "تایید درخواست خرید",
  RFPStep: "ثبت درخواست پیشنهاد",
  TechnicalProposalStep: "ثبت پیشنهاد فنی",
  CommercialProposalStep: "ثبت پیشنهاد بازرگانی",
  TBEStep: "ارزیابی پیشنهاد فنی",
  CBEStep: "ارزیابی پیشنهاد بازرگانی",
  VendorSelectionStep: "انتخاب تامین کننده",
  ContractConfirmedStep: "تایید قرارداد خرید",
  POStep: "ثبت سفارش",
  PackingStep: "پکینگ",
  FinalInspectionStep: "بازرسی نهایی",
  StartTansportationStep: "شروع حمل",
  FinishTansportationStep: "پایان حمل",
  ReceiptStep: "ثبت رسید انبار",
  budgtingList: "لیست بودجه بندی ",
  cost: "هزینه",
  income: "درآمد",
  cashFlow: "جریان نقدی",

  forecast: "پیش بینی",
  earnedValue: "ارزش کسب شده",
  actual: "واقعی",
  variance: "انحراف",
  activity: "فعالیت",
  in: "ورودی",
  out: "خروجی",
  ResouceList: "لیست منابع",
  externalProcurement: "خرید خارجی",
  estimatedWork: " براورد کار",
  performedWork: "کار انجام شده",
  userList: "لیست کاربران",
  clientUser: "کاربر کارفرما",
  consultantUser: "کاربر مشاور",
  noComment: "بدون کامنت",
  observed: "مشاهده شد",
  updateBudgetWithExcel: "بروزرسانی بودجه با اکسل",
  submitPlanWithExcel: "ثبت برنامه با اکسل",
  recordProcessed: "رکورد پردازش و آماده ثبت است!",
  revisionConfirmationEdit: "ویرایش گردش کار",
  removeLastWorkFlow: "حدف گردش کار",
  editLastWorkFlow: "تغییر گردش کار",
  choseWorkflowEditType: "انتخاب عملیات گردش کار",
  sysAdmin: "ادمین سیستم",
  admin: "ادمین",
  ContractMng: "مدیریت پروژه",
  ContractReg: "ثبت پروژه",
  ContractObs: "مشاهده پروژه",
  BomMng: "مدیریت لیست تجهیزات",
  BomObs: "مشاهده لیست تجهیزات",
  MrpMng: "مدیریت برنامه تامین",
  MrpObs: "مشاهده برنامه تامین",
  PurchaseRequestConfirm: "تایید درخواست خرید",
  PurchaseRequestReg: "ثبت درخواست خرید",
  PurchaseRequestObs: "مشاهده درخواست خرید",
  RFPMng: "مدیریت درخواست پیشنهاد",
  RFPObs: "مشاهده درخواست پیشنهاد",
  RFPWinnerMng: "مدیریت انتخاب پروپوزال",
  RFPTechMng: "مدیریت پروپوزال فنی",
  RFPTechObs: "مشاهده پروپوزال فنی",
  RFPTechEvaluationMng: "ارزیابی پروپوزال فنی",
  RFPCommercialMng: "مدیریت پیشنهاد بازرگانی",
  RFPCommercialObs: "مشاهده پیشنهاد بازرگانی",
  RFPCommercialEvaluationMng: "ارزیابی پروپوزال بازرگانی",
  PrContractMng: "مدیریت قرارداد خرید",
  PrContractReg: "ثبت قرارداد خرید",
  PrContractObs: "مشاهده قرارداد خرید",
  POMng: "مدیریت سفارش خرید",
  POObs: "مشاهده سفارش خرید",
  POActivityMng: "مدیریت فعالیت های سفارش خرید",
  PackMng: "مدیریت پکینگ سفارش خرید",
  PackQCMng: "مدیریت بازرسی پکینگ",
  RFPWinnerObs: "مشاهده انتخاب پروپوزال",
  LogisticMng: "مدیریت حمل و نقل سفارش خرید",
  POActivityOwner: "بروزرسانی فعالیت سفارش خرید",
  WarehouseMng: "مدیریت رسید انبار",
  WarehouseObs: "مشاهده رسید انبار",
  WarehouseQCMng: "کنترل کیفیت رسید انبار",
  InvoiceMng: "مدیریت فاکتور خرید",
  POFinancialObs: "مشاهده مالی سفارش خرید",
  InvoiceObs: "مشاهده فاکتور خرید",
  PaymentMng: "مدیریت پرداخت",
  PaymentObs: "مشاهده پرداخت",
  FinancialAccountMng: "مشاهده صورتحساب تامین کنندگان",
  TeamworkMng: "مدیریت تیم ها",
  TeamworkObs: "مشاهده تیم ها",
  POFinancialMng: "مدیریت مالی سفارش خرید",
  DocumentGroupMng: "مدیریت گروه مدارک",
  DocumentGroupObs: "مشاهده گروه مدارک",
  DocumentMng: "مدیریت لیست مدارک",
  DocumentObs: "مشاهده لیست مدارک",
  DocumentArchiveObs: "مشاهده آرشیو مدرک",
  DocumentArchiveLimitedObs: "مشاهده محدود آرشیو مدرک",
  RevisionMng: "مدیریت تهیه مدرک",
  RevisionObs: "مشاهده تهیه مدرک",
  RevisionActivityMng: "بروزرسانی فعالیت مدرک",
  RevisionConfirmMng: "تایید تهیه مدرک",
  TransmittalMng: "مدیریت ترانسمیتال",
  TransmittalObs: "مشاهده ترانسمیتال",
  TransmittalLimitedObs: "مشاهده محدود ترانسمیتال",
  UserMng: "مدیریت کاربران",
  UserObs: "مشاهده کاربران",
  ProductMng: "مدیریت گروه کالا",
  ProductObs: "مشاهده گروه کالا",
  SupplierMng: "مدیریت تامین کنندگان",
  SupplierObs: "مشاهده تامین کنندگان",
  CustomerMng: "مدیریت کارفرما",
  CustomerObs: "مشاهده کارفرما",
  ComCommentLimitedObs: "مشاهده محدود کامنت شیت",
  ComCommentObs: "مشاهده کامنت شیت",
  ComCommentReg: "ثبت کامنت شیت",
  ComCommentReply: "پاسخ به کامنت شیت",
  ComCommentMng: "مدیریت کامنت شیت",
  TQLimitedObs: "مشاهده محدود TQ",
  TQObs: "مشاهده TQ",
  TQReg: "ثبت TQ",
  TQReply: "پاسخ به TQ",
  TQMng: "مدیریت TQ",
  NCRLimitedObs: "مشاهده محدود NCR",
  NCRObs: "مشاهده NCR",
  NCRReg: "ثبت NCR",
  NCRReply: "پاسخ به NCR",
  NCRMng: "مدیریت NCR",
  DocumentGlbObs: "مشاهده آزاد لیست مدارک",
  DocumentArchiveLimitedGlbObs: "مشاهده آزاد آرشیو مدرک",
  RevisionGlbObs: "مشاهده آزاد تهیه مدرک",
  RevisionConfirmGlbMng: "تایید آزاد تهیه مدرک",
  TransmittalLimitedGlbObs: "مشاهده آزاد ترانسمیتال",
  ComCommentLimitedGlbObs: "مشاهده آزاد کامنت شیت",
  TQLimitedGlbObs: "مشاهده  آزاد TQ",
  NCRLimitedGlbObs: "مشاهده آزاد NCR",
  RevisionCreator: "ایجاد تهیه مدرک",
  OperationGroupMng: "مدیریت گروه اجرا",
  OperationGroupObs: "مشاهده گروه اجرا",
  OperationListObs: "مشاهد لیست عملیات",
  OperationListMng: "مدیریت لیست عملیات",
  OperationListGlbObs: "مشاهده آزاد لیست عملیات",
  OperationInProgressObs: "مشاهده انجام عملیات",
  OperationInProgressMng: "مدیریت انجام عملیات",
  OperationInProgressGlbObs: "مشاهده آزاد انجام عملیات",
  OperationActivityUpd: "بوزرسانی فعالیت عملیات ",
  FileDriveObs: "مشاهده فایل دراایو عمومی",
  FileDriveMng: "مدیریت فایل درایو عمومی",
  PrivateMng: "فایل درایو شخصی",
  RFPProFormaObs: "مشاهده پیش فاکتور",
  RFPProFormaMng: "مدیریت پیش فاکتور",
  POInspectionMng: "مدیریت بازرسی سفارش خرید",
  POInspectionObs: "مشاهده بازرسی سفارش خرید",
  POSupplierDocumentMng: "مدیریت مدارک تامیین کننده سفارش خرید",
  POSupplierDocumentObs: "مشاهده مدارک تامیین کننده سفارش خرید",
  WareHouseOutputRequestReg: "ثبت درخواست کالا از انبار",
  WareHouseOutputRequestConfirm: "تایید درخواست کالا از انبار",
  WareHouseOutputRequestObs: "مشاهده درخواست کالا از انبار",
  WarehouseDispatchMng: "مدیریت خروج  کالا از انبار",
  WarehouseDispatchObs: "مشاهده خروج کالا از انبار",
  WarehouseInventoryObs: "مشاهده موجودی انبار",
  PaymentConfirm: "تایید پرداخت",
  ComCommentLimitedGlbReply: "پاسخ آزاد به کامنت شیت",
  TQLimitedGlbReply: "پاسخ آزاد به TQ",
  NCRLimitedGlbReply: "پاسخ آزاد به NCR",
  AnomlayMng: "مدیریت آنومالی",
  AnomlayReg: "ثبت آنومالی",
  AnomlayObs: "مشاهده آنومالی",
  AnomlayConfirm: "تایید آنومالی",
  SchedulingObs: "مشاهده زمان",
  SchedulingMng: "مدیریت زمان",
  BudgetingObs: "مشاهده بودجه بندی",
  BudgetingMng: "مدیریت بودجه بندی",
  ResourceObs: "مشاهده منابع",
  ResourceMng: "مدیریت منابع",
  Admin: "ادمین",
  SYSADMIN: "سوپر ادمین",
  roles: "نقش ها",
  userHasNoTeam: "این کاربر در هیچ تیمی اضافه نشده است!",
  row: "ردیف",
  modules: "بخش",
  updateDocumentWithExcel: "ویرایش مدرک از طریق فایل",
  editDocuments: "ویرایش مدارک",
  editPOI: "ویرایش P.O.I",
  removeTransmittalWarning: "آیا از حذف ترانسمیتال  مطمئن هستید؟",
  privateGroup: "گروه خصوصی",
  privateGroupTip: "گروهی خصوصی برای تبادل اطلاعات",
  taskGroupTip: "تسک بسازید، مسئول و زمان سررسید مشخص کنید ",
  task: "تسک",
  createNewPrivateGroup: "ایجاد گروه خصوصی جدید",
  createNewGroupTip: "نوشتن پیام و دعوت اعضا به گروه",
  createNewTaskTip: "نوشتن پیام و دعوت اعضا به تسک",
  createNewTask: "ایجاد تسک جدید",
  groupSubject: "موضوع گروه",
  taskSubject: "موضوع تسک",
  createGroup: "ثبت گروه",
  createTask: "ثبت تسک",
  removePurchaseRequestWarning: "آیا از حذف درخواست خرید مطمئن هستید؟",
  isCommented: "دارای کامنت",
  allMessage: "همه",
  unreadMessage: "خوانده نشده",
  incompleteTask: "انجام نشده",
  conversations: "گفت‌وگوها",
  noAction: "ندارد",
  insuranceDeposit: "سپرده بیمه",
  performanceBond: "حسن انجام کار",
  finalBook: "فاینال بوک",
  rejectReasonPartOne: "این مدرک توسط ",
  rejectReasonPartTwo: " در تاریخ ",
  rejectReasonPartThree: " به دلیل زیر رد شده است! ",
  product: "کالا",
  newProduct: "کالای جدید",
  newProductList: "لیست کالاهای جدید",
  otherProducts: "سایر کالاها",
  services: "خدمات",
  serviceList: "لیست خدمات",
  serviceName: "نام خدمت",
  newServiceList: "لیست خدمات جدید",
  newService: "خدمت جدید",
  changeSubjectServiceDeliveryWarning: "آیا از انجام این عملیات مطمئن هستید؟",
};
